<div
  class="table"
  [style]="{ 'padding-bottom': '32px', height: wrapperHeight }"
>
  <div class="p-d-flex p-jc-between p-ai-end personalize-filter">
    <div #toolbar class="mb-5">
      <button
        *ngIf="showDelete"
        pButton
        label="{{ 'SigvLibrary.Delete' | translate }}"
        icon="pi pi-delete"
        class="p-button-action p-button-outlined p-content-button mr-10"
        (click)="onDeleteBtnClick()"
      ></button>
      <button
        *ngIf="complex"
        pButton
        label="{{ 'SigvLibrary.FilterColumns' | translate }}"
        icon="pi pi-filter"
        class="p-button-action p-button-outlined p-content-button mr-10"
        (click)="onColumnFilterBtnClick($event)"
      ></button>
      <ng-container *ngIf="toolbarTemplate">
        <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
      </ng-container>
    </div>
    <p-multiSelect
      *ngIf="complex"
      sigvDropdownSetting
      [(ngModel)]="selectedFields"
      [options]="filterColumnOptions"
      [appendTo]="toolbar"
      (onPanelHide)="onMultiSelectClose($event)"
      optionLabel="label"
      optionValue="value"
      [overlayVisible]="isOpenColumnFilter"
      [showToggleAll]="false"
      placeholder="{{ 'SigvLibrary.ChooseOption' | translate }}"
      (onChange)="onMultiSelectChange($event)"
      (onPanelHide)="onColumnOptionMultiSelectPanelHide()"
      [style]="{ width: '300px' }"
    >
      <ng-template pTemplate="item" let-item>
        {{ item.label | translate }}
      </ng-template>
    </p-multiSelect>
    <button
      *ngIf="sort"
      pButton
      icon="pi pi-teaching"
      tooltipEvent="focus"
      [escape]="false"
      tooltipStyleClass="p-tool-w400"
      pTooltip="{{ 'SigvLibrary.SortToolTip' | translate }}"
      tooltipPosition="bottom"
      class="p-button-action p-button-outlined p-button-teaching mb-5"
    ></button>
  </div>
  <p-table
    [value]="value"
    [columns]="displayColumns"
    [first]="first"
    (firstChange)="onFirstChange($event)"
    [scrollable]="scrollable"
    scrollHeight="flex"
    [loading]="loading"
    [resetPageOnSort]="false"
    [reorderableColumns]="true"
    [editMode]="editable ? 'row' : ''"
    [sortMode]="sort ? 'multiple' : ''"
    [selection]="selection"
    (selectionChange)="onSelectionChange($event)"
    [paginator]="paging"
    [lazy]="lazy"
    [rowsPerPageOptions]="rowsPerPageItems"
    [rows]="10"
    [showCurrentPageReport]="true"
    [dataKey]="dataKey"
    [totalRecords]="totalRecords"
    currentPageReportTemplate="{{ 'SigvLibrary.PaginationInfo' | translate }}"
    (onSort)="onTableSort($event)"
    (onPage)="onTablePaging($event)"
    (onColReorder)="onColReorder($event)"
    (onStateRestore)="onTableStateRestore($event)"
    (onStateSave)="onTableStateSave($event)"
  >
    <ng-template pTemplate="caption">
      <ng-container *ngIf="captionTemplate">
        <ng-container *ngTemplateOutlet="captionTemplate"></ng-container>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngIf="selectable" style="width: 120px" />
        <col
          *ngFor="let col of columns"
          [style.width]="col.width ? col.width : 'auto'"
        />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <ng-container *ngIf="headerTemplate; else defaultHeader">
        <ng-container
          *ngTemplateOutlet="headerTemplate; context: { $implicit: columns }"
        ></ng-container>
      </ng-container>
      <ng-template #defaultHeader>
        <tr>
          <th *ngIf="selectable">
            <div class="p-d-inline-flex p-ai-center">
              <p-tableHeaderCheckbox
                [ngClass]="{
                  'p-datatable-icon-button-space': true,
                  'p-datatable-header-checkbox-selected-some':
                    selection.length > 0 && selection.length < value.length
                }"
              >
              </p-tableHeaderCheckbox>
              <span>{{ "SigvLibrary.CheckAll" | translate }}</span>
            </div>
          </th>
          <th
            pReorderableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sortable"
            *ngFor="let col of columns"
          >
            {{ col.header | translate }}
            <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-row
      let-columns="columns"
      let-rowIndex="rowIndex"
      let-expanded="expanded"
      let-editing="editing"
    >
      <ng-container *ngIf="bodyTemplate">
        <ng-container *ngIf="selectable || editable; else bodyContainer">
          <tr
            [pSelectableRow]="row"
            [pSelectableRowIndex]="rowIndex"
            [pEditableRow]="row"
            [class.p-editing]="editing"
            [class.p-highlight]="row.create"
          >
            <td>
              <div class="p-d-flex p-ai-center p-jc-center">
                <ng-container *ngIf="selectable">
                  <p-tableCheckbox
                    *ngIf="!editing && !row.create"
                    [value]="row"
                    class="p-datatable-icon-button-space"
                  >
                  </p-tableCheckbox>
                </ng-container>
                <ng-container *ngIf="editable">
                  <button
                    *ngIf="!editing && !row.create"
                    pButton
                    pInitEditableRow
                    icon="pi pi-pen"
                    (click)="onRowEditInit(row)"
                    class="p-button-rounded p-button-text"
                  ></button>
                  <button
                    *ngIf="editing && !row.create"
                    pButton
                    pSaveEditableRow
                    icon="pi pi-confirm"
                    (click)="onRowEditSave(row)"
                    class="
                      p-button-rounded
                      p-button-text
                      p-button-success
                      p-datatable-icon-button-space
                    "
                  ></button>
                  <button
                    *ngIf="editing && !row.create"
                    pButton
                    pCancelEditableRow
                    icon="pi pi-cancel"
                    (click)="onRowEditCancel(row, rowIndex)"
                    class="p-button-rounded p-button-text"
                  ></button>
                </ng-container>
                <ng-container *ngIf="row.create">
                  <button
                    pButton
                    pSaveEditableRow
                    icon="pi pi-confirm"
                    (click)="onRowCreateSave(row)"
                    class="
                      p-button-rounded
                      p-button-text
                      p-button-success
                      p-datatable-icon-button-space
                    "
                  ></button>
                  <button
                    pButton
                    pCancelEditableRow
                    icon="pi pi-cancel"
                    (click)="onRowCreateCancel(row, rowIndex)"
                    class="p-button-rounded p-button-text"
                  ></button>
                </ng-container>
              </div>
            </td>
            <ng-container *ngTemplateOutlet="bodyContainer"></ng-container></tr
        ></ng-container>

        <ng-template #bodyContainer>
          <ng-container
            *ngTemplateOutlet="
              bodyTemplate;
              context: {
                $implicit: row,
                rowIndex: rowIndex,
                columns: columns,
                expanded: expanded,
                editing: editing
              }
            "
          >
          </ng-container>
        </ng-template>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <ng-container *ngIf="paginatorrightTemplate">
        <ng-container *ngTemplateOutlet="paginatorrightTemplate"></ng-container>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td class="p-text-center" [attr.colspan]="colSpanCount">
          {{ "SigvLibrary.NoData" | translate }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td
          *ngIf="canCreateRow"
          [attr.colspan]="colSpanCount"
          class="mt-20 p-text-center"
        >
          <button
            pButton
            label="SigvLibrary.Create"
            icon="pi pi-add-white"
            class="p-button-secondary p-content-button"
            [disabled]="hasUnConfirmedNewRows"
            (click)="onCreateRowBtnClick()"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<sigv-content-dialog
  *ngIf="canCreateRow"
  [(visible)]="showCreateDialog"
  dialogSize="large"
  (confirm)="onCreateRowDialogConfirm()"
>
  <ng-container *ngTemplateOutlet="createDialogContentTemplate"></ng-container>
</sigv-content-dialog>
